import ActionTypes from '../../constants/ActionTypes';

const initialState = {
  isSubmitting: false,
  error: null,
};

// eslint-disable-next-line default-param-last
export default (state = initialState, { type, payload }) => {
  switch (type) {
    case ActionTypes.CARD_RELATION_CREATE:
      return {
        ...state,
        isSubmitting: true,
        error: null,
      };

    case ActionTypes.CARD_RELATION_CREATE__SUCCESS:
      return initialState;

    case ActionTypes.CARD_RELATION_CREATE__FAILURE:
      return {
        ...state,
        isSubmitting: false,
        error: payload.error,
      };

    case ActionTypes.CARD_RELATION_CREATE_ERROR_CLEAR:
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
};
